import React from 'react';
import {
  InnerContainerStyled,
  ReviewNoteSectionStyled,
  ReviewNoteSubtitleStyled,
  ReviewNoteTitleStyled,
} from './styles';

const ReviewNote: React.FC = () => {
  return (
    <ReviewNoteSectionStyled>
      <InnerContainerStyled>
        <ReviewNoteTitleStyled>IMPORTANT!</ReviewNoteTitleStyled>
        <ReviewNoteSubtitleStyled>
          Please review your elections carefully. Any elections left blank will automatically be waived at the end of
          open enrollment. Also review your profile and dependents information. Errors may delay processing.
        </ReviewNoteSubtitleStyled>
      </InnerContainerStyled>
    </ReviewNoteSectionStyled>
  );
};

export default ReviewNote;
